import format from 'string-format'

// replace our tags with something with <>
const replaceTags = (value) => {
  if (!value) return value
  let text = value
  const replacers = [
    {
      s: 'b',
      replace: 'strong',
    },
    {
      s: 'sup',
      replace: 'sup',
    },
  ]

  replacers.forEach((rep) => {
    const regex1 = new RegExp(`\\[${rep.s}\\]`, 'g') // open tag
    const regex2 = new RegExp(`\\[/${rep.s}\\]`, 'g') // close tag
    text = text.replace(regex1, `<${rep.replace}>`).replace(regex2, `</${rep.replace}>`)
  })

  return text
}

// replace non breaking spaces [s]
const nonBreakinSpace = (value) => {
  if (!value) return value
  const regexSpace = new RegExp('\\[s\\]', 'g')
  return value.replace(regexSpace, '&nbsp;')
}

// break
const breaktag = (value) => {
  const regexBreak = new RegExp('\\[br\\]', 'g')
  return value.replace(regexBreak, '</br>')
}

// replace [info]id[/info] with clickable infoicons
const infoBlock = (value) => {
  if (!value) return value
  const regexInfo = new RegExp('\\[info\\](.*?)\\[/info\\]', 'g') // information popup is [info]id[/info]
  const resultInfo = regexInfo.exec(value)
  if (resultInfo) {
    return value.replace(
      regexInfo,
      `<a class="info-symbol" role="button" data-info-popup="${resultInfo[1]}"></a>`
    )
  }
  return value
}

// const image = (value) => {
//   if (!value) return value;
//   const regexImage = new RegExp('\\[img\\](.*?)\\[/img\\]', 'g'); // image element is [img]fileName[/info]
//   const resultImage = regexImage.exec(value);
//   if (resultImage) {
//     const element = document.createElement('img');
//     element.style = 'max-width: 100%;';
//     element.src = require(`shared/assets/images/${resultImage[1]}.png`);
//     var elementHtml = element.outerHTML;
//     return value.replace(regexImage, elementHtml);
//   }
//   return value;
// };

const anchor = (value) => {
  const regEx = new RegExp(/\[a\|([^[]+)\]([^[]+)\[\/a\]/gi)
  const transformedLink = value.replace(regEx, (_, url, label) => {
    if (url.indexOf('|') !== -1) {
      const target = url.split('|')[1] === 'blank' ? ' target="_blank"' : ''
      return `<a${target} href="${url.split('|')[0]}">${label}</a>`
    } else return `<a href="${url}">${label}</a>`
  })
  return transformedLink
}

const scrolltop = (value) => {
  const regexScroll = new RegExp('\\[scrolltop\\](.*?)\\[/scrolltop\\]', 'g')
  const resultScroll = regexScroll.exec(value)
  if (resultScroll) {
    const replaced = value.replace(
      resultScroll[0],
      `<a class="link" role="button" scrollto="top">${resultScroll[1]}</a>`
    )
    return replaced
  }
  return value
}

// replace {i} by dynamic content
const placeholders = (value, args) => (args ? format(value, ...args) : value)

export const replaceDynamicContent = (value, args) => {
  if (value === '') {
    return null
  }
  if (value) {
    let text = value

    // apply all placeholders
    text = replaceTags(text)
    text = nonBreakinSpace(text)
    text = infoBlock(text)
    // text = image(text);
    text = anchor(text)
    text = scrolltop(text)
    text = breaktag(text)

    // dynamic content

    text = placeholders(text, args)

    return text
  }
  return null
}
